const CommonTypes = {
  ERROR_HARD_RESET: 'ERROR_HARD_RESET',
};

export default CommonTypes;
